export const PAGE_KEY = 'time-attendance-collaborator-tracker-widget';
